export default __webpack_public_path__ + "static/slider-2-f3de406174aa71ad21ee57785ba3fc0d.jpg";